import { Switch, Route } from "react-router-dom";
import EquipeIndex from "./EquipeIndex";
import EquipeNew from "./EquipeNew";
import EquipeEdit from "./EquipeEdit";
import EquipeShow from "./EquipeShow";

export default function EquipePage() {
    return (
        <Switch>
            <Route exact path="/equipe" component={EquipeIndex} />
            <Route path="/equipe/novo" component={EquipeNew} />
            <Route path="/equipe/edit/:id" component={EquipeEdit} />
            <Route path="/equipe/show/:id" component={EquipeShow} />
        </Switch>
    );
}
